import { Flex } from "@chakra-ui/react";

export function HeaderLink({ to, children, ...other }) {
  return (
    <Flex
      px={"8px"}
      _hover={{
        background: "gray.sombre",
        color: "theme.light",
      }}
      alignItems={"center"}
      onClick={() => {
        window.open(`https://app.ktx.finance${to}`, "_blank");
      }}
      cursor="pointer"
      {...other}
    >
      {children}
    </Flex>
  );
}
